var NewsSearch = {
    newsResultsPerPage: 11,
    newsExcludeId: 0,
    newsRootId: 0,
    newsCurrentResultPage: 1,

    docType: "newsArticle",
    partialView: "NewsResult_Rows",

    newsResultTarget: null,
    loadMoreTarget: null,

    me: this,

    InitNewsSearch: function (_resultsPerPage, _highlightedArticle, _rootId) {
        this.newsResultsPerPage = _resultsPerPage;
        this.newsExcludeId = _highlightedArticle;
        this.newsRootId = _rootId;
        this.newsResultTarget = document.querySelector('#nextPageOfResults');
        this.loadMoreTarget = document.querySelector('#loadMoreNews');

        this.loadMoreTarget.addEventListener("click", function (e) {
            e.preventDefault();
            //console.log('load more');
            this.DoSearch();
        }.bind(this));

        document.querySelectorAll('.search__aggregation input[type=checkbox]').forEach(function (key) {
            key.addEventListener("change", function (e) {
                e.preventDefault();
                this.newsCurrentResultPage = 1;
                this.newsResultTarget.innerHTML = "";
                this.DoSearch();
            }.bind(this));
        }.bind(this));

        document.querySelector('.news__filter--button').addEventListener('click', function () {
            document.querySelector('.news__filter').classList.toggle('news__filter--active');
        });

        window.onload = function () {
            document.querySelectorAll('.card__news--share-icon').forEach(function (element) {
                element.addEventListener('click', function () {
                    this.parentElement.classList.toggle('card__news--share-active');
                });
            });
        };

        this.DoSearch();
    },

    DoSearch: function () {
        let prom = this.GetSearchResults();
        prom.then(
            function (result) {
                //console.log(this);
                if (this.newsCurrentResultPage < result.pages) {
                    this.loadMoreTarget.classList.remove('hidden')
                    //this.newsResultTarget.innerHTML += result.htmlResults;
                } else {
                    this.loadMoreTarget.classList.add('hidden')
                    //this.newsResultTarget.innerHTML = result.htmlResults;
                }

                this.newsResultTarget.innerHTML += result.htmlResults;
                this.newsCurrentResultPage++;
            }.bind(this)   // Bind the parent scope to this
        );
    },

    GetSearchParams: function () {
        var newsTags = nodeListToIds(document.querySelectorAll('.search__aggregation input[type=checkbox][data-group="newsTags"]'));

        var params = {
            resultsPerPage: this.newsResultsPerPage,
            rootNode: this.newsRootId,
            excludeId: this.newsExcludeId,
            currentResultPage: this.newsCurrentResultPage,
            docType: this.docType,
            partialView: this.partialView,
            dateFilterField: 'displayDateIndex',

            // Facets
            newsTags: newsTags
        };

        console.log(params);

        return params;
    },

    GetSearchResults: function () {
        let searchParams = this.GetSearchParams();

        return new Promise(function (resolve, reject) {
            fetch('/umbraco/surface/NewsSearch/DoNewsSearchView', {
                body: JSON.stringify(searchParams), method: 'post', headers: { 'Accept': 'application/json', 'Content-Type': 'application/json' },
            })
                .then(function (response) {
                    //console.log('response : %o', response.json());
                    resolve(response.json());
                })
                .catch(error => {
                    console.log('Failed', error);
                    reject(error);
                });
        });
    }
}